export enum Lizenz {
  Ad = 'WebAd',
  Pr = 'WebPr',
  Bj = 'WebBj',
  Urp = 'WebUrp',
  Arp = 'WebRp',
  QrScanner = 'QrScanner',
  Lieferschein = 'WebLieferschein',
}
